export default __webpack_public_path__ + "static/platform-layers-left-74b44bad34c5d684c7618640d6f1de74.svg";